define([
    // 'WebCommon/component/page-header-new',
    // 'WebCommon/component/page-footer-new',
    'WebCommon/component/page-header2024',
    'WebCommon/component/page-footer-new',

    'WebCommon/init',
    'css!WebCommon/css/global.css',
    'css!WebCommon/css/common.css'
], function(
    // PageHeaderPhone,
    PageHeader,
    PageFooter
){
    return {
        components: {
            // PageHeaderPhone: PageHeaderPhone,
            PageHeader: PageHeader,
            PageFooter: PageFooter
        }
    };
});



//////////////////
// WEBPACK FOOTER
// ../common/mixin/page.js
// module id = 20
// module chunks = 0 1 2 3 4 5 6 7 8